import { motion } from "framer-motion";
import { NeuralMapLayer } from "./NeuralMapLayer";

export function FinalState({ t, caseId, mapData, onReturn }) {
  return (
    <div data-testid="final-state" className="relative min-h-screen flex flex-col items-center justify-center text-center px-6">
      {mapData && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 0.35 }}
          transition={{ duration: 2, ease: [0.16, 1, 0.3, 1], delay: 0.3 }}
          className="absolute inset-0"
        >
          <NeuralMapLayer interpretation={mapData} />
        </motion.div>
      )}

      <motion.div
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.2, ease: [0.16, 1, 0.3, 1], delay: 0.5 }}
        className="relative z-10 max-w-2xl"
      >
        <h2 className="font-display font-extrabold uppercase tracking-tight text-3xl md:text-5xl leading-[1.05]">
          {t.final.title}
        </h2>
        <p className="mx-auto mt-6 max-w-lg text-base md:text-lg text-bh-soft leading-relaxed">{t.final.body}</p>

        {caseId && (
          <div className="mt-10">
            <div className="text-[11px] uppercase tracking-[0.25em] text-bh-c2">{t.final.caseLabel}</div>
            <div data-testid="case-id" className="mt-2 font-display text-xl md:text-2xl tracking-tight">
              {caseId}
            </div>
          </div>
        )}

        <button
          data-testid="return-btn"
          onClick={onReturn}
          className="group mt-12 inline-flex items-center gap-3 text-base"
        >
          <span className="transition-transform duration-500 group-hover:-translate-x-1">←</span>
          <span className="relative">
            {t.final.cta}
            <span className="absolute left-0 -bottom-1 h-px w-full bg-bh-ink origin-right scale-x-100 group-hover:scale-x-0 transition-transform duration-500" />
            <span className="absolute left-0 -bottom-1 h-px w-full bg-bh-ink origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-500 delay-100" />
          </span>
        </button>
      </motion.div>
    </div>
  );
}
